// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"761":"QQShare","857":"WxLaunchHack"}[chunkId] || chunkId) + "." + {"67":"82715d25af","761":"96b323eb96","857":"3dffd086b4"}[chunkId] + ".js";
};